import { connect } from 'react-redux';

import { getCategories } from '../actions/categories';

import { categoriesSelector } from '../reducers/categories';

import AdminCategoriesListPageComponent from '../components/AdminCategoriesListPage';

const mapStateToProps = state => {
  return {
    categories: categoriesSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    getCategories: () => dispatch(getCategories()),
  };
};

const AdminCategoriesListPage = connect(mapStateToProps, mapDispatchToProps)(AdminCategoriesListPageComponent);

export default AdminCategoriesListPage;
